<template>
  <div class="list-table-thead">
    <div class="table-1 flex-1">姓名</div>
    <!-- 全天 -->
    <template v-if="dynamicHeader.indexOf('0') != -1">
      <div class="table-3 flex-2">
        <!-- <div class="top">全天</div> -->
        <div class="flex status">
          <span>到校</span>
          <span>离校</span>
        </div>
      </div>
    </template>
    <!-- 其余 -->
    <template v-else>
      <div class="table-3 flex-1" v-for="item in dynamicHeader" :key="item">
        <div class="top">{{ headerTitle[Number(item)] }}</div>
        <div class="flex status">
          <span>到校</span>
          <span>离校</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    dynamicHeader: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headerTitle: ['全天', '上午', '下午', '早上', '晚上']
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.list-table-thead {
  display: flex;
  padding: 0 0 1rem 0;
  margin: 0 1rem;
  /* border-top: 0.06rem solid #f4f4f6; */
  border-bottom: 0.06rem solid #f4f4f6;
  align-items: center;
  text-align: center;

  color: #78849e;
  font-size: 0.75rem;
  .table-1 {
    border-right: 0.06rem solid #f4f4f6;
    padding: 0.8rem 0;
  }
  .table-3 {
    border-right: 0.06rem solid #f4f4f6;

    .top {
      margin: 0 0.8rem;

      padding: 0.3rem 0;
      border-bottom: 0.06rem solid #f4f4f6;
    }
    .status {
      padding: 0.3rem 0;
      span {
        flex: 1;
      }
    }
    .status-fullday {
      padding: 0.8rem 0;
      span {
        flex: 1;
      }
    }
  }
}
</style>
